<template>
  <div id="personPlanContainer">
    <div class="left">
      <div style="
          border-bottom: 1px solid #d0d7e6bf;
          padding: var(--middle-space) var(--big-space);
          color: var(--key-color);
          font-size: 16px;
          font-weight: 600;
        ">
        人员列表
      </div>
      <div class="leftNav">
        <!-- 目录树 -->
        <roleTree @systemTableClick="clickNodeTree"></roleTree>
      </div>
    </div>
    <div class="right">
      <div class="rightTop">
        <div class="operations">
          <el-tooltip :disabled="currentDataShow" class="item" effect="light" content="选择角色后策划人员" placement="bottom"
            popper-class="eltooltipcehua">
            <span>
              <el-button v-if="addpersonPlan" :disabled="!currentDataShow" size="small" class="btnBgColor"
                type="primary" @click="addMemberPerson">
                策划人员
              </el-button>
            </span>
          </el-tooltip>
          <el-button v-if="delepersonPlan" size="small" plain class="btnBgColor" type="danger" @click="delPerson">
            删除
          </el-button>
          <el-button v-if="invPersonPlan" size="small" plain class="btnBgColor" type="primary"
            @click="invitationPerson">
            添加更多人员
          </el-button>
          <el-button v-if="childPersonPlan" size="small" plain class="btnBgColor" type="primary" @click="gochildPersonPlan"> {{ $titles.child }}成员 </el-button>
        </div>

        <div class="searchAndWarning">
          <div class="search">
            <el-input v-model.trim="searchValue" type="text" size="small" placeholder="请输入姓名、账号、专业、角色" title="请输入姓名、账号、专业、角色"
              prefix-icon="el-icon-search" clearable @keyup.enter.native="search">
            </el-input>
            <el-button type="primary" style="margin-left: var(--small-space)" size="small" @click="search">
              搜索
            </el-button>
          </div>
        </div>
      </div>
      <div class="rightBottom">
        <el-table ref="multipleTable" v-loading="tableLoading" :data="list" border element-loading-text="数据加载中..."
          tooltip-effect="dark" empty-text="" height="100%" @selection-change="selectChange">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size: 16px; color: #000">暂无数据</p>
          </template>
          <el-table-column :selectable="checkboxInit" type="selection" width="55" align="center"
            @selection-change="selectChange">
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="姓名" prop="name">
          </el-table-column>
          <el-table-column show-overflow-tooltip align="center" label="账号" prop="userName">
          </el-table-column>

          <el-table-column show-overflow-tooltip prop="specName" align="center" label="专业" />
          <el-table-column v-if="!hideSubitem" show-overflow-tooltip prop="stageName" align="center" label="阶段" />
          <el-table-column v-if="!hideSubitem" show-overflow-tooltip prop="stageChildName" align="center" :label="$titles.child" />
          <el-table-column show-overflow-tooltip prop="roleName" align="center" label="角色">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="enterPrjTime" align="center" label="进入项目时间">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import request from "@/CommonDP/service/personPlan-service";
import roleTree from "@/CommonDP/components/structure/roleTree";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import requestprj from "@/CommonDP/service/integratedModel-service";
import globalParams from "@/CommonDP/utils/globalParams";
import { openMember } from "@/CommonDP/components/chooseMember/leftCom.js";
export default {
  name: "PersonPlan",
  components: { roleTree },

  data() {
    return {

      hideSubitem: false,
      loading: true,
      tableLoading: false,
      addLoading: false,
      addLoadingTxt: "数据加载中...",
      loadingTxt: "数据加载中...",
      searchValue: "",
      treeData: [],
      list: [],
      searchList: [],
      defaultProps: { children: "childList", label: "roleName" },
      selectArr: [],
      pageNo: 1,
      pageSize: 9999,
      currentNode: {},
      currentData: {},
      isShowAddPerson: false,
      personAll: [],
      personOther: [],
      confirmPerson: [],
      filterMethod(query, item) {
        return item.name.indexOf(query) > -1;
      },
      propsObj: {
        key: "userID"
      },
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      currentDataShow: false,
      planParams: {}
    };
  },

  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    addpersonPlan() {
      return checkPermission(this.$allPerms.PERSONPLAN_ADD);
    },
    delepersonPlan() {
      return checkPermission(this.$allPerms.PERSONPLAN_DELE);
    },
    invPersonPlan() {
      return checkPermission(this.$allPerms.PERSONPLAN_INVITATION);
    },
    childPersonPlan() {
      return checkPermission(this.$allPerms.SHILDPERSONPLAN);
    }
  },

  watch: {
    searchValue(newValue) {
      if (!newValue) {
        this.queryPersonList(this.currentData, this.currentNode);
      }
    }
  },

  created() {
    this.hideSubitem = globalParams.get("project.person.hideSubitem");
  },

  methods: {
    gochildPersonPlan() {
      this.$router.push({
        path: "/project-childPersonPlan"
      });
    },
    invitationPerson() {
      const a = disablePrompt();
      if (a) {
        this.$router.push({
          path: "/project-invitePersonPlan",
          query: { showType: "invite" }
        });
      }
    },
    checkboxInit(row) {
      if (row.isPrjManageUser) {
        return 0;
      } else {
        return 1;
      } // 可勾选
    },
    rightData(val) {
      this.confirmPerson = val;
    },
    clickNodeTree(data) {
      this.queryPersonList(data[0], data[1]);
      this.currentNode = data[1];
      this.currentData = data[0];
      if (data[0].childList) {
        this.currentDataShow = false;
      } else {
        this.currentDataShow = true;
      }
    },
    async queryPersonList(data, node) {
      this.tableLoading = true;
      const { roleId } = data;
      const { prjId } = this.prjInfo;
      const { specId, stageChildId } = this.findFirstNode(node);
      const params = {
        specId,
        roleId,
        prjId,
        stageChildId,
        enterpriseId: this.enterpriseId
      };
      try {
        if (data.$isOperation === 1) delete params.roleId;
        const result = await request.queryPersonList(params);
        if (result.result === "0") {
          this.list = result.data;
          this.searchList = result.data;
          this.tableLoading = false;
        }
      } catch (e) {
        this.tableLoading = false;
        this.$message.warning(e.message || "查询人员失败");
      }
    },

    findFirstNode(node) {
      let specId = "";
      let specName = "";
      let stageChildId = "";
      let stageChildName = "";
      const arr = [node];
      while (arr[0]) {
        const lastNode = arr[0];
        const data = lastNode.data || {};
        if (data.specId) {
          specId = data.specId;
        }

        if (data.specName) {
          specName = data.specName;
        }

        if (data.stageChildId) {
          stageChildId = data.stageChildId;
        }

        if (data.stageChildName) {
          stageChildName = data.stageChildName;
        }

        arr.pop();
        if (lastNode.parent) arr.push(lastNode.parent);
      }
      return {
        specId,
        specName,
        stageChildId,
        stageChildName
      };
    },

    async addMemberPerson() {
      const props = {
        filterOneself: false,
        max: 100,
        codePri: ["User"]
      };
      const val = await openMember(props);
      if (val.length >= 1) {
        this.confirmAddPerson(val);
      }
    },

    async delPerson() {
      if (!this.selectArr[0]) return this.$message.warning("请选择人员");
      const newData = this.selectArr.map((item) => item.id);
      await this.$confirm("确定删除吗?");
      this.loadingTxt = "删除中...";
      this.loading = true;
      try {
        const result = await request.delPerson(newData);
        if (result.result === "0") {
          this.loading = false;
          this.$message({
            type: "success",
            message: "删除成功"
          });
          this.queryPrjlist();
        }
      } catch (e) {
        this.loading = false;
        this.$message.warning(e.message || "删除失败");
      }
    },
    async queryPrjlist() {
      const { prjId } = this.prjInfo;
      const params = {
        enterpriseId: this.enterpriseId,
        prjName: "",
        prjCode: "",
        prjType: "",
        prjLevel: ""
      };
      const result = await requestprj.queryPrj(params);
      const projectInfo = result.data.find((item) => item.prjId === prjId);
      if (result.data.length) {
        if (!projectInfo) {
          // this.$store.dispatch("setDelPersonKey", result.data);
          this.$store.dispatch("myProjectsChange");
        } else {
          this.queryPersonList(this.currentData, this.currentNode);
        }
      } else {
        const data = {
          createTime: "",
          enterPrjTime: "",
          prjCode: "",
          prjId: "",
          prjName: ""
        };
        this.$store.dispatch("updatePrj", data);
        this.$router.push({ name: "noproject" });
      }
    },
    renderFunc(h, option) {
      return h("div", {
        on: {
          dblclick: () => {
            let addToType = "";
            const idType = "userID";
            let checkedType = "";
            this.$refs.elTransfer.value.includes(option[idType])
              ? ((addToType = "addToLeft"), (checkedType = "rightChecked"))
              : ((addToType = "addToRight"), (checkedType = "leftChecked"));
            this.$refs.elTransfer[checkedType].push(option.userID);
            this.$refs.elTransfer[addToType](option);
          }
        },
        domProps: {
          innerText: option.name
        },
        attrs: {
          title: option.name,
          class: "ellipsis"
        }
      });
    },

    async confirmAddPerson(params) {
      this.addLoadingTxt = "人员策划中...";
      this.addLoading = true;
      const { prjId, prjName } = this.prjInfo;
      const { roleId, roleName } = this.currentData;
      const { specId, specName, stageChildId, stageChildName } = this.findFirstNode(this.currentNode);
      const userList = params;
      try {
        const result = await request.addPerson({
          prjId,
          prjName,
          specId,
          specName,
          stageChildId,
          stageChildName,
          roleId,
          roleName,
          userList,
          enterpriseId: this.enterpriseId
        });
        if (result.result === "0") {
          this.$message.success("人员策划成功");
          await this.queryPersonList(this.currentData, this.currentNode);
          this.addLoading = false;
          this.$store.dispatch("unreadNum");
        }
      } catch (e) {
        this.addLoading = false;
        this.$message.warning(e.message || "人员策划失败");
      }
    },

    search() {
      const { searchValue: name } = this;
      if (!name) {
        return this.$message.warning("请输入用户名、账号、专业、角色");
      }
      this.loadingTxt = "搜索中...";
      this.loading = true;
      setTimeout(() => {
        this.list = this.searchList.filter((item) => this.filterKeyword(item, name));
        this.loading = false;
      }, 500);
    },

    filterKeyword(item, name) {
      const keyArr = ["name", "userName", "specName", "roleName"];
      let flag = false;
      while (keyArr[0] && !flag) {
        if (item[keyArr.shift()].includes(name)) flag = true;
      }
      return flag;
    },

    selectChange(selection) {
      this.selectArr = selection;
    },
    findImagePath(data) {
      if (data.childList) {
        return require(`@/CommonDP/assets/wenjianjia.png`);
      } else {
        return require(`@/CommonDP/assets/avatar.png`);
      }
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#personPlanContainer {
  width: 100%;
  height: 100%;
  display: flex;

  .left {
    width: 280px;
    height: 100%;
    margin-right: var(--middle-space);
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;

    .leftNav {
      width: 280px;
      height: 1px;
      flex-grow: 1;
      background-color: #fff;
      overflow: hidden;
      box-sizing: border-box;
    }
    .leftNav:hover{
      overflow: auto;
    }

    .textAll {
      width: 150px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 14px;
    }
  }

  .right {
    width: calc(100% - 280px - var(--middle-space));
    height: 100%;
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;

    .rightTop {
      border-top-left-radius: 4px;
      width: 100%;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: var(--middle-space) var(--big-space);
      box-sizing: border-box;
      border-bottom: 1px solid #eee;

      .operations {
        display: flex;
        align-items: center;

        .btnBgColor {
          margin-right: var(--small-space);
          margin-left: 0 !important;
        }
      }

      .searchAndWarning {
        display: flex;
        align-items: center;

        .warning {
          display: flex;
          align-items: center;
          margin-right: 30px;

          span {
            color: red;
            white-space: nowrap;
            padding: 0 15px;
            background-color: #fba7c0;
            border-radius: 12px;
            margin-left: 2px;
          }
        }

        .search {
          display: flex;
          align-items: center;
          width: 330px;
        }
      }
    }

    .rightBottom {
      width: 100%;
      height: 1px;
      flex-grow: 1;
      padding: var(--middle-space) var(--big-space);
      box-sizing: border-box;
    }
  }

  /deep/ .el-dialog {
    .el-dialog__body {
      text-align: center;
      position: relative;

      .el-transfer {
        .el-transfer-panel {
          text-align: left;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.tabTransfer {
  >>> .el-tabs__content {
    height: 100%;
  }
  >>> .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border: none;
  }
  >>> .el-input__inner {
    border-radius: 3px;
  }
  >>> .el-tabs__header {
    margin: 0 0 6px;
  }
}
</style>
<style lang="scss">
#personPlanContainer {
  .tabTransfer-dialog {
    border-radius: 5px;
    .el-dialog__body {
      padding-bottom: 57px !important;
      border-top: 1px solid #2e5bff1a;
      border-bottom: 1px solid #2e5bff1a;
    }
    .el-select {
      width: 100%;
    }
  }
}
.eltooltipcehua {
  border: 1px solid #dde3f2 !important;
}
.eltooltipcehua .popper__arrow {
  border-bottom-color: #dde3f2 !important;
  border-top-color: #dde3f2 !important;
}
</style>
